// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { dispatchEvent } from 'fg-frontend/src/lib/dom';
import $ from 'jquery';
import cookie from 'js-cookie';


const fragments = {
  ITEM: '[data-fragment="FilterOfFilter.item"]',
  INPUT: '[data-fragment="FilterOfFilter.input"]',
  RESET: '[data-fragment="FilterOfFilter.reset"]',
  SELECTALL: '[data-fragment="FilterOfFilter.selectAll"]',
  COUNT: '[data-fragment="FilterOfFilter.count"]',
  CLEAR: '[data-fragment="FilterOfFilter.clearInput"]',
};

class FilterOfFilter extends WebComponent {
  constructor(props) {
    super(props);
    this.doFilter = this.doFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.clearInput = this.clearInput.bind(this);
  }
  didMount() {
    const {
      saveState,
    } = this.props;

    this.group = this.element;
    this.items = this.group.querySelectorAll(fragments.ITEM);
    this.input = this.group.querySelector(fragments.INPUT);
    this.reset = this.group.querySelector(fragments.RESET);
    this.selectAll = this.group.querySelector(fragments.SELECTALL);
    this.count = this.group.querySelector(fragments.COUNT);
    this.clearBtn = this.group.querySelector(fragments.CLEAR);

    if (this.items) {
      this.getSelectedItems();
    }

    if (this.input && this.items) {
      this.input.addEventListener('keyup',this.doFilter);
      if (saveState) {
        this.getFromCookie();
      }
    }

    if (this.reset) {
      this.reset.addEventListener('click',this.handleReset);
    }
    if (this.selectAll) {
      this.selectAll.addEventListener('click',this.handleSelectAll);
    }
    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', this.clearInput);
    }
  }

  clearInput(e) {
    this.input.value = '';
    dispatchEvent(this.input,'keyup');
  }

  getSelectedItems() {
    let selectedItems = 0;
    this.items.forEach((item) => {
        if (item.querySelector('input:checked')) {
          selectedItems = selectedItems + 1;
        }
    });
    this.selectedItems = selectedItems;

    this.count.innerHTML = `(${this.selectedItems})`;
    if (this.selectedItems > 0) {
      this.count.classList.remove('hidden');
      if (this.reset) {
        this.reset.classList.remove('hidden');
      }
      if (this.selectAll) {
        this.selectAll.classList.add('hidden');
      }
      this.group.classList.add('filled');
    }
    else {
      this.count.classList.add('hidden');
      if (this.reset) {
        this.reset.classList.add('hidden');
      }
      if (this.selectAll) {
        this.selectAll.classList.remove('hidden');
      }
      this.group.classList.remove('filled');
    }
  }

  handleReset(e) {
    e.preventDefault();
    let changed = false;
    let input;

    this.items.forEach((item) => {
      input = item.querySelector('input');

      if (input.checked) {
        input.checked = false;
        changed = true;
      }
    });

    if (changed) {
      $(input).trigger('change');
    }
  }

  handleSelectAll(e) {
    e.preventDefault();
    let changed = false;
    let input;

    this.items.forEach((item) => {
      if (!item.classList.contains('hidden')) {
        input = item.querySelector('input');

        if (!input.checked) {
          input.checked = true;
          changed = true;
        }
      }
    });

    if (changed) {
      $(input).trigger('change');
    }
  }

  // filter handler
  doFilter(e) {
    const value = e.target.value.toLowerCase();
    const {
      saveState,
    } = this.props;

    if (saveState) {
      this.saveValueToCookie(this.group.id, value);
    }

    let label, labelText;
    if (value != '') {

      if (this.clearBtn) {
        this.clearBtn.classList.remove('hidden');
      }

      this.items.forEach((item) => {
        label = item.querySelector('.checkbox__label');
        if (label) {
          labelText = label.textContent.toLowerCase();
          if (labelText.indexOf(value) > -1) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        }
      });
    }

    if (value == '') {
      if (this.clearBtn) {
        this.clearBtn.classList.add('hidden');
      }
      this.items.forEach((item) => {
        item.classList.remove('hidden');
      });
    }
  }

  saveValueToCookie(id, value) {
    cookie.set(`fof_${id}`, {value: value, path: window.location.pathname});
  }

  getFromCookie() {
    const cookieValue = cookie.get('fof_' + this.group.id);

    if (typeof(cookieValue) !== 'undefined') {

      const cookieObject = JSON.parse(cookieValue);
      if (cookieObject.path == window.location.pathname) {
        this.input.value = cookieObject.value;
        dispatchEvent(this.input,'keyup');
      }
    }
  }
}

FilterOfFilter.defaultProps = {
  saveState: false,
};

export default FilterOfFilter;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FilterOfFilter.js